export interface ConvertCheckInstructorRequest {
    FlightSchoolInstructorId?: number;
    FlightSchoolExaminerId?: number;
    InstructorCertificateNumber?: string;
    ConvertCheckInstructorType: ConvertCheckInstructorType;
}

export enum ConvertCheckInstructorType {
    ConvertFromFlightInstructor = 1,
    ConvertFromPilotExaminer = 2
}